import type { RouteRecordRaw } from "vue-router";
import { Language } from "@/Common/Models/Domain/Language";

import { APP_SETTINGS_CONFIGURATION_ROUTES as CONFIGURATION } from "@/Generated/Routes/paths";
import { buildBeforeEnterChain, onlyLanguageGuard } from "@/Router/guards";

const configuration: RouteRecordRaw[] = [
  {
    ...CONFIGURATION.root,
    meta: {
      i18nTitle: `settings.configuration.my_preferences-title`,
    },
    component: () => import("@/Views/settings/configuration/Configuration.vue"),
  },
  {
    ...CONFIGURATION.schedule.root,
    meta: {
      i18nTitle: `settings.configuration.my_preferences_schedule-title`,
    },
    component: () => import("@/Views/settings/configuration/schedule/Schedule.vue"),
  },
  {
    ...CONFIGURATION.areas.root,
    meta: {
      i18nTitle: `settings.configuration.my_preferences_reasons-title`,
    },
    component: () => import("@/Views/settings/configuration/areas/Areas.vue"),
  },
  {
    ...CONFIGURATION.therapeuticApproaches.root,
    meta: {
      i18nTitle: `settings.configuration.my_preferences_therapeutic_approaches-title`,
    },
    component: () => import("@/Views/settings/configuration/therapeuticApproaches/TherapeuticApproaches.vue"),
  },
  {
    ...CONFIGURATION.educations.root,
    meta: {
      i18nTitle: `settings.configuration.my_preferences_educations-title`,
    },
    component: () => import("@/Views/settings/configuration/education/Education.vue"),
  },
  {
    ...CONFIGURATION.additionalLanguages.root,
    meta: {
      i18nTitle: `settings.configuration.additional_languages-title`,
    },
    component: () => import("@/Views/settings/configuration/AdditionalLanguages.vue"),
    beforeEnter: buildBeforeEnterChain(onlyLanguageGuard([Language.SPANISH])),
  },
  {
    ...CONFIGURATION.capaticy.root,
    meta: {
      i18nTitle: `settings.configuration.my_preferences_patients-title`,
    },
    component: () => import("@/Views/settings/configuration/numberPatients/Capacity.vue"),
  },
  {
    ...CONFIGURATION.trial.root,
    meta: {
      i18nTitle: `settings.configuration.my_preferences_trial_period-title`,
    },
    component: () => import("@/Views/settings/configuration/trialPeriod/TrialPeriod.vue"),
  },
  {
    ...CONFIGURATION.pricePerSession.root,
    meta: {
      i18nTitle: "settings.configuration.price_per_session",
    },
    component: () => import("@/Views/settings/configuration/PricePerSession.vue"),
  },
  {
    ...CONFIGURATION.timeZone.root,
    component: () => import("@/Views/settings/configuration/TimeZone.vue"),
    meta: {
      i18nTitle: "settings.configuration.time_zone.title",
    },
  },
];

export default configuration;
